module.exports = __webpack_public_path__ + "static/media/email.8daeddca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/social/email.svg
// module id = 30
// module chunks = 0